// utils/formatHTML.js

/**
 * Converts FAQ data into an HTML-friendly string
 * suitable for chatbot ingestion or visual preview.
 *
 * @param {Array} data - The FAQ data array
 * @param {string} language - The current language (default: 'en')
 * @returns {string} HTML output string
 */
export function convertToHTML(data, language = 'en') {
  if (!Array.isArray(data)) return '<p>No FAQ data available</p>';

  const htmlContent = data
    .map(category => {
      const faqItems = category.details || category.faqList || [];
      const itemsHTML = faqItems
        .map((item, i) => {
          const question = escapeHTML(item.question || item.title || '');
          const answer = escapeHTML(item.answer || item.description || '');
          return `
            <div class="faq-item">
              <h3 class="faq-question">${i + 1}. ${question}</h3>
              <p class="faq-answer">${answer}</p>
            </div>
          `;
        })
        .join('');

      return `
        <section class="faq-category">
          <h2 class="faq-category-title">${escapeHTML(
            category.categoryName || 'Untitled Category'
          )}</h2>
          ${itemsHTML}
        </section>
      `;
    })
    .join('');

  return `
    <div class="faq-root" lang="${language}">
      ${htmlContent}
    </div>
  `;
}

/** Helper to escape HTML special characters */
function escapeHTML(str = '') {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
